import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.FirstStartModule.CreateOrganisationPopup.InitialContent', {
    dearButton: 'Connect to Cin7 Core',
    netSuiteButton: 'Connect to NetSuite',
    xeroButton: 'Connect to Xero',
    qboButton: 'Connect to QuickBooks Online',
});
